import React, { PropTypes } from 'react';
import classNames from 'classnames';
import { ContentType, ContentStatus } from 'enums';
import WatchPropTypes from 'common/PropTypes';
import injectIntl, { intlShape } from 'common/injectIntl';

const Stamp = ({
    isTile,
    content,
    intl: { formatMessage },
    messages,
    userIsBlackedOut
}) => {
    const { type, status, duration, shortDate } = content;
    const stampClass = classNames('media-duration', {
        'media-duration--item': isTile, // gotta pass in the parent doing the embedding because of this class, not cool
        'media-duration--live': status === ContentStatus.LIVE,
        'media-duration--blackout': userIsBlackedOut
    });

    let stampContent = null;
    if (userIsBlackedOut) {
        stampContent = formatMessage(messages.blackout);
    } else if (type === ContentType.VOD) {
        // TODO: DTC - remove fallback once `content` has `duration` for VOD
        stampContent = duration || content.streams[0].duration;
    } else {
        switch (status) {
            case ContentStatus.LIVE:
                stampContent = formatMessage(messages.live);
                break;
            case ContentStatus.UPCOMING: {
                stampContent = shortDate;
                break;
            }
            case ContentStatus.REPLAY:
                // TODO: DTC - remove fallback once `content` has `duration` for VOD
                stampContent = duration || content.streams[0].duration;
                break;
            default:
                stampContent = duration || null;
        }
    }

    if (stampContent) {
        return (<div className={stampClass}>{stampContent}</div>);
    }
    return null;
};

Stamp.propTypes = {
    isTile: PropTypes.bool,
    content: WatchPropTypes.content,
    userIsBlackedOut: PropTypes.bool,
    intl: intlShape.isRequired,
    messages: PropTypes.object.isRequired
};

export default injectIntl(Stamp);



// WEBPACK FOOTER //
// ./app/webapp/common/Stamp.js